import { NOTE_COLORS, NOTE_COLOR_LABELS, type NoteColor } from '@keep/shared';

/** Teintes de Google Keep, en thème clair et sombre. Exposées en variables CSS (--note-<couleur>). */
export const NOTE_COLOR_VALUES: Record<NoteColor, { light: string; dark: string }> = {
  default: { light: '#ffffff', dark: '#202124' },
  coral: { light: '#faafa8', dark: '#77172e' },
  peach: { light: '#f39f76', dark: '#692b17' },
  sand: { light: '#fff8b8', dark: '#7c4a03' },
  mint: { light: '#e2f6d3', dark: '#264d3b' },
  sage: { light: '#b4ddd3', dark: '#0c625d' },
  fog: { light: '#d4e4ed', dark: '#256377' },
  storm: { light: '#aeccdc', dark: '#284255' },
  dusk: { light: '#d3bfdb', dark: '#472e5b' },
  blossom: { light: '#f6e2dd', dark: '#6c394f' },
  clay: { light: '#e9e3d4', dark: '#4b443a' },
  chalk: { light: '#efeff1', dark: '#232427' },
};

export const noteColorVar = (color: NoteColor) => `var(--note-${color})`;

export const NOTE_COLOR_OPTIONS = NOTE_COLORS.map((id) => ({ id, label: NOTE_COLOR_LABELS[id] }));

/** Génère les variables CSS des couleurs (injectées une fois au démarrage). */
export function noteColorCss(): string {
  const vars = (mode: 'light' | 'dark') =>
    NOTE_COLORS.map((c) => `--note-${c}:${NOTE_COLOR_VALUES[c][mode]};`).join('');
  return `:root{${vars('light')}}:root.dark{${vars('dark')}}`;
}
